import { AlertCircle } from "lucide-react";
import { focusField } from "../../lib/notify";
import { missingRequired } from "./personnelShared";

// Kaydet'e basmadan eksik zorunlu alanlar: kırmızı özet, çipe tıklayınca alana gider
export default function RequiredSummary({ form }) {
  const miss = missingRequired(form);
  if (!miss.length) return null;
  const go = (testid) => { const el = document.querySelector(`[data-testid="${testid}"]`); if (el) focusField(el); };
  return (
    <div className="rounded-md border border-red-300 bg-red-50 px-3 py-2 flex items-center gap-2 flex-wrap text-xs text-red-900" data-testid="pf-required-summary">
      <AlertCircle className="w-4 h-4 text-red-700 shrink-0" />
      <span className="font-bold uppercase">Eksik zorunlu alanlar ({miss.length}):</span>
      {miss.map((m) => (
        <button key={m.key} type="button" onClick={() => go(m.testid)} data-testid={`pf-required-${m.key}`} className="px-2 py-0.5 rounded-md border border-red-400 bg-white font-semibold hover:bg-red-100">{m.label}</button>
      ))}
      <span className="text-red-700">— kaydetmek için tamamlayın</span>
    </div>
  );
}
